import { render, staticRenderFns } from "./CreateBioPart7.vue?vue&type=template&id=2bd3fc17&"
import script from "./CreateBioPart7.vue?vue&type=script&lang=js&"
export * from "./CreateBioPart7.vue?vue&type=script&lang=js&"
import style0 from "./CreateBioPart7.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports